<div class="search-container bg-white" *ngIf="mobile_search_view_state.display">


   <div class="search-bar">

     <div class="back-icon-container" (click)="hideSearchBar()">
       <img
         src="../../../../assets/header-mobile-img/left-arrow.png"
         class="back-icon"
         alt=""
       />
     </div>


     <div
       class="d-flex px-1"
     >
       <!-- **warning translate placeholder -->
       <input
         type="text"
         class="search-input w-100"
         placeholder="{{ 'search_text' | translate : 'header' }}"
         (input)="searching($event);"
         [value]="mobile_search_view_state.search_text"
       />
       <div
         class="empty-search-container d-flex align-items-center justify-content-end pe-1"
         (click)="emptySearchInput()"
       >
         <img
           src="../../../../assets/header-mobile-img/close.png"
           class="empty-search"
           alt=""
         />
       </div>
     </div>


     <div class="d-flex flex-column justify-content-center vr-container">
       <div class="vr"></div>
     </div>


     <div class="search-icon-container d-flex align-items-center">
       <img
         src="../../.././../assets/header-mobile-img/search.png"
         class="search-icon"
         alt=""
       />
     </div>

   </div>
 
 
   <div class="suggestions d-flex flex-column">

     <div class="suggestion px-3 py-2" *ngFor="let result of mobile_search_view_state.search_result">
         
         <div class="m-0 d-flex gap-1 search-result" (click)="redirect(result)">
            <span>{{ result?.name }}</span>
            <span *ngIf="result?.brand" class="text-danger">
               <span>(</span>
               <span>{{ result?.brand?.name }}</span>
               <span>)</span>
            </span>
         </div>

     </div>

   </div>
 
 
 </div>